
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
name: 'step5',
directives: {
TransferDom
},
components: {
Previewer
},
data () {
return {
list: [
{
msrc: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E5%85%A5%E5%A2%83%E6%97%85%E5%AE%A2%E8%BB%8C%E8%B7%A1%E5%8D%A1%E5%8F%8A%E7%A7%BB%E4%BA%A4%E8%A8%98%E9%8C%84%E5%96%AE%402x.png',
src: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E5%85%A5%E5%A2%83%E6%97%85%E5%AE%A2%E8%BB%8C%E8%B7%A1%E5%8D%A1%E5%8F%8A%E7%A7%BB%E4%BA%A4%E8%A8%98%E9%8C%84%E5%96%AE%402x.png',
w: 600,
h: 400
},
{
msrc: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E5%80%99%E8%BB%8A%E8%99%95%402x.png',
src: 'https://mylink.oss-accelerate.aliyuncs.com/5gact/greenchannel/%E5%80%99%E8%BB%8A%E8%99%95%402x.png',
w: 600,
h: 400
}
],
options: {
getThumbBoundsFn (index) {

let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]

let pageYScroll = window.pageYOffset || document.documentElement.scrollTop


let rect = thumbnail.getBoundingClientRect()

return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
}
}
}
},
methods: {
logIndexChange (arg) {
console.log(arg)
},
show (index) {
this.$refs.previewer.show(index)
}
}
}



// WEBPACK FOOTER //
// ./src/page/greenchannel/component/process.vue